import React from "react";
import styles from "./ERPModal.module.css";

import {
  BackArrowButton,
  CancelButton,
  CloseButton,
  ProceedButton,
} from "../../../fixedassetelements/button/Button";

import DocIcon from "../../../assets/icons/doc.svg";
import CalendarIcon from "../../../assets/icons/Calendar.svg";
import MenuIcon from "../../../assets/icons/menuDotBlack.svg";
import EmptyBox from "../../../assets/icons/empty-box.png";

const CurrencyIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.rowIcon}
  >
    <circle cx="12" cy="12" r="9" stroke="#1A4338" strokeWidth="1.75" />
    <path
      d="M12 7V17M9.5 9.5H14.5C15.3284 9.5 16 10.1716 16 11C16 11.8284 15.3284 12.5 14.5 12.5H9.5C8.67157 12.5 8 13.1716 8 14C8 14.8284 8.67157 15.5 9.5 15.5H14.5"
      stroke="#1A4338"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ERPModal = ({
  onClose,
  onBack,
  onProceed,
  onCancel,
  erpList = [],
  selectedCardId,
  setSelectedCardId,
  isLoading = false,
}) => {
  const displayList = (erpList || []).flatMap((pkg, pkgIdx) => {
    if (Array.isArray(pkg.data) && pkg.data.length > 0) {
      return pkg.data.map((entry, entryIdx) => ({
        ...entry,
        _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
        packageId: pkg._id || pkg.id,
        posting_date: entry.posting_date || pkg.datecreated || pkg.createdAt,
      }));
    }
    return [pkg];
  });

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={styles.title}>
              Add Loans Register (Pull from ERP)
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.description}>
          <p>
            Select an ERP package to pull your register data from <br />
            Choose a package and click proceed.
          </p>
        </div>

        <div className={styles.content}>
          {isLoading ? (
            <div className={styles.emptyState}>Loading ERP packages...</div>
          ) : displayList && displayList.length > 0 ? (
            <div className={styles.cardContainer}>
              {displayList.map((item) => (
                <div
                  key={item._id || item.id}
                  className={`${styles.card} ${
                    selectedCardId === (item._id || item.id)
                      ? styles.selectedCard
                      : ""
                  }`}
                  onClick={() => setSelectedCardId(item._id || item.id)}
                >
                  <div className={styles.cardHeader}>
                    <span className={styles.companyName}>
                      {item.company || item.companyName || "Company Name"}
                    </span>
                    <button className={styles.menuButton}>
                      <img src={MenuIcon} alt="menu" />
                    </button>
                  </div>

                  <div className={styles.cardBody}>
                    <div className={styles.cardRow}>
                      <img
                        src={DocIcon}
                        alt="name"
                        className={styles.rowIcon}
                      />
                      <span className={styles.rowText}>
                        {item.name || item.data?.[0]?.name || "-"}
                      </span>
                    </div>

                    <div className={styles.cardRow}>
                      <CurrencyIcon />
                      <span className={styles.rowText}>
                        {item.currency || item.data?.[0]?.currency || "INR"}
                      </span>
                    </div>

                    <div className={styles.cardRow}>
                      <img
                        src={CalendarIcon}
                        alt="posting date"
                        className={styles.rowIcon}
                      />
                      <span className={styles.rowText}>
                        {item.posting_date ||
                          item.data?.[0]?.posting_date ||
                          (item.datecreated
                            ? new Date(item.datecreated).toISOString().split("T")[0]
                            : item.createdAt
                            ? new Date(item.createdAt).toISOString().split("T")[0]
                            : "-")}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.emptyState}>
              <img
                src={EmptyBox}
                alt="No ERP packages"
                className={styles.emptyStateImg}
              />
              <span className={styles.emptyStateText}>No ERP packages found</span>
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <CancelButton onClick={onCancel || onClose} />
          <ProceedButton onClick={onProceed} />
        </div>
      </div>
    </div>
  );
};

export default ERPModal;
